import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';

import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import MobileHeader from '../../components/MobileHeader/MobileHeader';

const ProfilePayment = React.createClass({
	mixins: [LinkedStateMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired
	},

	render() {
		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='profile'
					title='Payment'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content section-wrap bg-gray">
					<div className="section-body">
						<div className="profile-payment">
							<div className="profile-payment-graphic"></div>
							<div className="profile-payment-content">
								<div className="profile-payment-price">$15<span className="shy">/ month</span></div>
								<TouchLink to="/profile/payment/card" className="btn btn-primary">Purchase</TouchLink>
							</div>
						</div>
					</div>
					<div className="section-footer profile-payment-albert">
						<div className="bubble days-left">
							<div className="days">3</div>
							<div className="text">
								<span className="header">Days</span>
								<span>Of free trial remaining</span>
							</div>
						</div>
						<div className="albert"></div>
					</div>
				</div>
			</div>
		);
	}
});

export default ProfilePayment;


/** WEBPACK FOOTER **
 ** ./src/screens/profile/ProfilePayment.js
 **/